import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { AlertCircle } from '@finect/tabular-icons/alertCircle';
import { getFont } from '@finect/tabular-utils/getFont';
import { FeaturedInner, FeaturedLabel, Inner } from './partials';
var InfoText = styled(ParagraphSmall).withConfig({
  displayName: "LastProductCard__InfoText",
  componentId: "sc-1tfbi8w-0"
})(["margin-bottom:148px;", " color:", ";", " ", ""], getFont(0, 'compact'), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciary;
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'medium' ? 'margin-bottom: 64px' : '';
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant === 'cta' ? 'margin-bottom: 0px' : '';
});
var ViewMorwButton = styled(ButtonLined).withConfig({
  displayName: "LastProductCard__ViewMorwButton",
  componentId: "sc-1tfbi8w-1"
})(["display:flex;align-items:center;justify-content:space-between;white-space:nowrap;"]);
var ViewMoreContent = styled.div.withConfig({
  displayName: "LastProductCard__ViewMoreContent",
  componentId: "sc-1tfbi8w-2"
})(["padding:0 0 34px;", " ", ""], function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'medium' ? 'padding-bottom: 4px' : '';
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'cta' ? 'padding-bottom: 0' : '';
});
var InfoTitle = styled.h2.withConfig({
  displayName: "LastProductCard__InfoTitle",
  componentId: "sc-1tfbi8w-3"
})(["", " font-weight:600;"], getFont(2));
var WrapperInfo = styled.div.withConfig({
  displayName: "LastProductCard__WrapperInfo",
  componentId: "sc-1tfbi8w-4"
})(["padding:0 16px;margin-top:auto;> svg{color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.terciary;
});
export var LastProductCard = function LastProductCard(_ref7) {
  var viewMore = _ref7.viewMore,
    variant = _ref7.variant;
  var buttonProps = viewMore.link.type === 'client' ? {
    as: Link,
    to: viewMore.link.href
  } : {
    as: 'a',
    href: viewMore.link.href
  };
  return React.createElement(FeaturedInner, null, variant === 'large' ? React.createElement(FeaturedLabel, {
    featuring: ''
  }, 'Last Card') : null, React.createElement(Inner, null, React.createElement(WrapperInfo, null, React.createElement(AlertCircle, null), React.createElement(InfoTitle, null, viewMore.title), React.createElement(InfoText, {
    variant: variant
  }, viewMore.infoText), React.createElement(ViewMoreContent, {
    variant: variant
  }, React.createElement(ViewMorwButton, buttonProps, viewMore.link.text, React.createElement(ArrowRight, null))))));
};